import { RootState } from "app/store";

export const selectUserState = (state: RootState): string => state.auth.user;
